module.exports = __webpack_public_path__ + "img/huong_dan_chuyen_data_3.680c2340.png";